<!--OFFER PRICE SCREEN PASSENGER MAP-->
<ng-template [ngIf]="passengerDetailScreenData.bookingPassengerDetailType === 'offer-price-screen-passenger'">
  <div class="pass-details mt-3 commonFormsCss">
    <h3>Passenger Details</h3>
    <div class="paxpn">
      <ng-template [ngIf]="passengerDetailScreenData.passengerDetail.length > 0">
        <div class="row row-hdr">
          <div class="col-md-5">
            
            <span class="mrg-left row-hdr pl-2"><b>Name</b></span>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-3 hidden-sm hidden-xs hidden-md">
            <div class="row row-hdr smallFontSSize">
              <div class="col-sm-2">Type</div>
              <div class="col-sm-3">Base</div>
              <div class="col-sm-3">Tax</div>
              <div class="col-sm-4">Total</div>
            </div>
          </div>
          <div class="col-sm-2"></div>
        </div>
        <div class="row pl-0 pt-10"
          *ngFor="let passenger of passengerDetailScreenData.passengerDetail; let passengerIndex = index">
          <div class="col-md-5">
            <ul class="pass-deatils pl-2">
              <li class="ps-1">
                <a *ngIf="!isSMEUser">
                  <i (click)="addPassengerDetails(passengerIndex)" class="fa fa-id-card iconColor"></i>
                </a>
              </li>
              <li class="ps-1">
                <select (change)="updatePassengerDetailsInSandboxState()" [(ngModel)]="passenger.passengerNameTitle"
                  class="form-control form-select">
                  <option [selected]="passenger.passengerNameTitle === 'Mr'" value="Mr">Mr</option>
                  <option [selected]="passenger.passengerNameTitle === 'Mrs'" value="Mrs">Mrs</option>
                  <option [selected]="passenger.passengerNameTitle === 'Miss'" value="Miss">Miss</option>
                  <option [selected]="passenger.passengerNameTitle === 'Ms'" value="Ms">Ms</option>
                  <option [selected]="passenger.passengerNameTitle === 'Dr'" value="Dr">Dr</option>
                </select>
              </li>
              <li class="ps-1">
                <input type="text" (keypress)="updatePassengerDetailsInSandboxState()"
                  [(ngModel)]="passenger.passengerName" class="name form-control" placeholder="FirstName" />
              </li>
              <li class="ps-1">
                <input type="text" (keypress)="updatePassengerDetailsInSandboxState()"
                  [(ngModel)]="passenger.passengerSurName" class="name form-control" placeholder="LastName" />
              </li>
              <li class="ps-1">
                <select (change)="updatePassengerDetailsInSandboxState()" [(ngModel)]="passenger.passengerGender"
                  class="form-control form-select">
                  <option [selected]="passenger.passengerGender === 'Male'" value="Male">Male</option>
                  <option [selected]="passenger.passengerGender === 'Female'" value="Female">Female</option>
                </select>
              </li>
            </ul>
          </div>
          <div class="col-md-2 pl-0">
            <div class="d-flex flex-flow">
              <ng-template [ngIf]="passenger.passengerOtherDetails.passengerSelectedSeatDetails.length > 0">
                <div class="ps-1 pe-1">
                  <i class="baIcn ba-flight-seat"></i>
                </div>
                <div *ngFor="let seat of passenger.passengerOtherDetails.passengerSelectedSeatDetails"
                  class="ps-1 pe-1">{{ seat.seatRowNumber }} {{ seat.seatCoulmnName }}</div>
              </ng-template>
            </div>
            <div class="d-flex">
              <i style="width: 23px; display: inline-block"></i>
              <ng-template [ngIf]="passenger.passengerOtherDetails.passengerBaggageDetails.length > 0">
                <div *ngFor="let baggageDetail of passenger.passengerOtherDetails.passengerBaggageDetails"
                  class="ps-1 pe-1">
                  <i class="baIcn ba-check-bag ba-2xx"></i>
                </div>
              </ng-template>
            </div>
          </div>
          <div class="col-md-3 pt-7 hidden-sm hidden-xs hidden-md">
            <div class="row smallFontSSize">
              <div class="col-sm-2">{{ passenger.passengerType }}</div>
              <div class="col-sm-3">{{ roundPassengerDetailsPrice(passenger.basePrice) }}</div>
              <div class="col-sm-3">{{ roundPassengerDetailsPrice(passenger.taxPrice) }}</div>
              <div class="col-sm-4">{{ roundPassengerDetailsPrice(passenger.totalPrice) }} {{ passenger.currency }}
              </div>
            </div>
          </div>
          <div *ngIf="passenger.passengerType !== 'INF'" class="col-sm-2">
            <button *ngIf="!isSMEUser" type="button" (click)="addPrimeBookingBaggage(passengerIndex)" class="ba-btn ba-btn-sm-vthin ba-btn-w100" role="button" tooltip="ExcessBaggae">
              Add <i class="fa fa-suitcase"></i>
            </button>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</ng-template>
<!--END-->

<!-- YOUR BOOKING SCREEN PASSENGER MAP-->
<ng-template [ngIf]="passengerDetailScreenData.bookingPassengerDetailType === 'your-booking-screen-passenger'">
  <ng-template [ngIf]="passengerDetailScreenData.isMapped">
    <div class="pass-details mt-3 yourBk-passDetails commonFormsCss">
      <h3>Passenger Details</h3>
      <div class="paxpn">
        <ng-template [ngIf]="passengerDetailScreenData.passengerDetail.length > 0">
          <div class="row row-hdr">
            <div class="col-md-5">
              <span class="mrg-left row-hdr pl-2"><b>Name</b></span>
            </div>
            <div class="col-md-3"></div>

            <div class="col-md-4 hidden-sm hidden-xs hidden-md">
              <div class="row row-hdr smallFontSSize">
                <div class="col-sm-2">Type</div>
                <div class="col-sm-3">Base</div>
                <div class="col-sm-3">Tax</div>
                <div class="col-sm-4">Total</div>
              </div>
            </div>
            <div class="col-sm-2"></div>
          </div>
          <div class="row pl-0 pt-10"
            *ngFor="let passenger of passengerDetailScreenData.passengerDetail; let passengerIndex = index">
            <div class="col-md-5">
              <ul class="pass-deatils pl-2">
                <li class="wrapToggle commonFormsCss">
                  <ng-toggle *ngIf="yourBookingScreen && !yourBookingScreen.booking.isDisrupted"
                    onColor="{{ getModel().onColor }}" onText="{{ getModel().onText }}"
                    offColor="{{ getModel().offColor }}" offText="{{ getModel().offText }}"
                    [(ngModel)]="getModel().value"
                    (valueChange)="selectedPassengerForSplitBooking(passengerIndex, $event)" class="hide ms-3 mb-2 xsm">
                  </ng-toggle>
                </li>
                <li *ngIf="yourBookingScreen && !yourBookingScreen.booking.isDisrupted" class="pl-0">
                  <button type="button" class="textgrayColor iconColor dropdown-toggle" data-bs-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false">
                    <i class="fa fa-user-tag"></i>
                  </button>
                  <div class="showHideToggle toggleOrderDetails dropdown-menu">
                    <h4 class="mb-3" id="exampleModalLabel">Order Details</h4>
                    <ul class="tkpn2">
                      <ng-template [ngIf]="passenger.passengerOtherDetails.passengerTicketDetails.length > 0">
                        <li *ngFor="let ticketDetail of passenger.passengerOtherDetails.passengerTicketDetails">
                          <div class="row">
                            <div class="col-md-1 pl-0 pr-0 text-right">
                              <ng-template [ngIf]="ticketDetail.ticketType === 'T'">
                                <i class="fa fa-ticket-alt"></i>
                              </ng-template>
                              <ng-template [ngIf]="ticketDetail.ticketType === 'J'">
                                <i class="fa fa-suitcase"></i>
                              </ng-template>
                              <ng-template [ngIf]="ticketDetail.ticketType === 'M'">
                                <i class="fa fa-utensils"></i>
                              </ng-template>
                              <ng-template [ngIf]="ticketDetail.ticketType === 'D'">
                                <i class="baIcn ba-flight-seat ba-2x"></i>
                              </ng-template>
                              <ng-template [ngIf]="ticketDetail.ticketType === 'Q'">
                                <i class="fa fa-leaf leaf"></i>
                              </ng-template>
                            </div>
                            <div class="col-md-5">TICKET NUMBER</div>
                            <div class="col-md-5">{{ ticketDetail.ticketNumber }}</div>
                            <div class="col-md-1"></div>
                          </div>
                        </li>
                        <li class="divider"></li>
                      </ng-template>
                      <!--bag-->
                      <ng-template [ngIf]="passenger.passengerOtherDetails.passengerBaggageDetails.length > 0">
                        <li
                          *ngFor="let baggageDetail of passenger.passengerOtherDetails.passengerBaggageDetails; let serviceIndex = index">
                          <div class="row">
                            <div class="col-md-1 pl-0 pr-0 text-right">
                              <i class="baIcn ba-check-bag ba-2xx"></i>
                            </div>
                            <div class="col-md-5">{{ baggageDetail.baggageName }}</div>
                            <div class="col-md-5">{{ baggageDetail.flightSegmentNumber }}</div>
                            <div class="col-md-1 pl-0 pr-0">
                              <a href="#" data-bs-toggle="modal" data-bs-target="#deleteService"
                                (click)="deleteService('BAG', passengerIndex, serviceIndex)" class="deleteIcon"
                                alt="Cancel Item">
                                <i class="fa fa-trash"></i>
                              </a>
                            </div>
                          </div>
                        </li>
                        <li class="divider"></li>
                      </ng-template>
                      <ng-template [ngIf]="passenger.passengerOtherDetails.passengerSelectedBaggageDetail.length > 0">
                        <li
                          *ngFor="let serviceDetail of passenger.passengerOtherDetails.passengerSelectedBaggageDetail; let serviceIndex = index">
                          <div class="row">
                            <div class="col-md-1 pl-0 pr-0 text-right">
                              <i class="baIcn ba-check-bag ba-2xx grn"></i>
                            </div>
                            <div class="col-md-5">{{ serviceDetail.baggageName }}</div>
                            <div class="col-md-5">{{ serviceDetail.flightSegmentNumber }}</div>
                            <div class="col-md-1 pl-0 pr-0">
                              <a href="#"
                                (click)="removeServiceFromPassenger('BAG', passengerIndex, serviceIndex); addAncilliaries()"
                                class="deleteIcon" alt="Cancel Item">
                                <i class="fa fa-trash"></i>
                              </a>
                            </div>
                          </div>
                        </li>
                        <li class="divider"></li>
                      </ng-template>
                      <!--end-->

                      <!--meal-->
                      <ng-template [ngIf]="passenger.passengerOtherDetails.passengerMealDetails.length > 0">
                        <li
                          *ngFor="let serviceDetail of passenger.passengerOtherDetails.passengerMealDetails; let serviceIndex = index">
                          <div class="row">
                            <div class="col-md-1 pl-0 pr-0 text-right">
                              <i class="fa fa-utensils"></i>
                            </div>
                            <div class="col-md-5">{{ serviceDetail.baggageName }}</div>
                            <div class="col-md-5">{{ serviceDetail.flightSegmentNumber }}</div>
                            <div class="col-md-1 pl-0 pr-0">
                              <a href="#" data-bs-toggle="modal" data-bs-target="#deleteService"
                                (click)="deleteService('MEAL', passengerIndex, serviceIndex)" class="deleteIcon"
                                alt="Cancel Item">
                                <i class="fa fa-trash"></i>
                              </a>
                            </div>
                          </div>
                        </li>
                        <li class="divider"></li>
                      </ng-template>
                      <ng-template [ngIf]="passenger.passengerOtherDetails.passengerSelectedMealDetails.length > 0">
                        <li
                          *ngFor="let serviceDetail of passenger.passengerOtherDetails.passengerSelectedMealDetails; let serviceIndex = index">
                          <div class="row">
                            <div class="col-md-1 pl-0 pr-0 text-right">
                              <i class="fa fa-utensils grn"></i>
                            </div>
                            <div class="col-md-5">{{ serviceDetail.baggageName }}</div>
                            <div class="col-md-5">{{ serviceDetail.flightSegmentNumber }}</div>
                            <div class="col-md-1 pl-0 pr-0">
                              <a href="#" (click)="removeServiceFromPassenger('MEAL', passengerIndex, serviceIndex)"
                                class="deleteIcon" alt="Cancel Item">
                                <i class="fa fa-trash"></i>
                              </a>
                            </div>
                          </div>
                        </li>
                        <li class="divider"></li>
                      </ng-template>
                      <!--end-->

                      <!--disablityService-->
                      <ng-template [ngIf]="passenger.passengerOtherDetails.passengerDisablityServiceDetail.length > 0">
                        <li
                          *ngFor="let serviceDetail of passenger.passengerOtherDetails.passengerDisablityServiceDetail; let serviceIndex = index">
                          <div class="row">
                            <div class="col-md-1 pl-0 pr-0 text-right">
                              <i class="fa fa-wheelchair"></i>
                            </div>
                            <div class="col-md-5">{{ serviceDetail.baggageName }}</div>
                            <div class="col-md-5">{{ serviceDetail.flightSegmentNumber }}</div>
                            <div class="col-md-1">
                              <a href="#" data-bs-toggle="modal" data-bs-target="#deleteService"
                                (click)="deleteService('DisabilityAssistance', passengerIndex, serviceIndex)"
                                class="deleteIcon" alt="Cancel Item">
                                <i class="fa fa-trash"></i>
                              </a>
                            </div>
                          </div>
                        </li>
                        <li class="divider"></li>
                      </ng-template>
                      <ng-template
                        [ngIf]="passenger.passengerOtherDetails.passengerSelectedDisablityServiceDetail.length > 0">
                        <li
                          *ngFor="let serviceDetail of passenger.passengerOtherDetails.passengerSelectedDisablityServiceDetail; let serviceIndex = index">
                          <div class="row">
                            <div class="col-md-1 pl-0 pr-0 text-right">
                              <i class="fa fa-wheelchair grn"></i>
                            </div>
                            <div class="col-md-5">{{ serviceDetail.baggageName }}</div>
                            <div class="col-md-5">{{ serviceDetail.flightSegmentNumber }}</div>
                            <div class="col-md-1 pl-0 pr-0">
                              <a href="#"
                                (click)="removeServiceFromPassenger('DisabilityAssistance', passengerIndex, serviceIndex)"
                                class="deleteIcon" alt="Cancel Item">
                                <i class="fa fa-trash"></i>
                              </a>
                            </div>
                          </div>
                        </li>
                        <li class="divider"></li>
                      </ng-template>
                      <!--seat service-->
                      <ng-template [ngIf]="passenger.passengerOtherDetails.passengerSelectedSeatDetails.length > 0">
                        <li
                          *ngFor="let serviceDetail of passenger.passengerOtherDetails.passengerSelectedSeatDetails; let serviceIndex = index">
                          <div class="row">
                            <div class="col-md-1 pl-0 pr-0 text-right">
                              <i class="baIcn ba-flight-seat ba-2x"></i>
                            </div>
                            <div class="col-md-5">{{ serviceDetail.seatRowNumber }} {{ serviceDetail.seatCoulmnName }}
                              UnConfirmed</div>
                            <div class="col-md-5">{{ serviceDetail.flightNumber }}</div>
                            <div class="col-md-1 pl-0 pr-0"></div>
                          </div>
                        </li>
                        <li class="divider"></li>
                      </ng-template>
                      <ng-template [ngIf]="passenger.passengerOtherDetails.passengerSeatDetails.length > 0">
                        <li
                          *ngFor="let serviceDetail of passenger.passengerOtherDetails.passengerSeatDetails; let serviceIndex = index">
                          <div class="row">
                            <div class="col-md-1 pl-0 pr-0 text-right">
                              <i class="baIcn ba-flight-seat ba-2x"></i>
                            </div>
                            <div class="col-md-5">{{ serviceDetail.seatRowNumber }} {{ serviceDetail.seatCoulmnName }}
                            </div>
                            <div class="col-md-5">{{ serviceDetail.flightNumber }}</div>
                            <div class="col-md-1 pl-0 pr-0"></div>
                          </div>
                        </li>
                        <li class="divider"></li>
                      </ng-template>
                      <!--CARB-->
                      <ng-template
                        [ngIf]="passenger.passengerOtherDetails.passengerProductClimateServiceDetail.length > 0">
                        <li
                          *ngFor="let serviceDetail of passenger.passengerOtherDetails.passengerProductClimateServiceDetail; let serviceIndex = index">
                          <div class="row">
                            <div class="col-md-1 pl-0 pr-0 text-right">
                              <i class="fa fa-leaf"></i>
                            </div>
                            <div class="col-md-5">{{ serviceDetail.baggageName }}</div>
                            <div class="col-md-5">{{ serviceDetail.flightSegmentNumber }}</div>
                            <div class="col-md-1 pl-0 pr-0">
                              <a href="#" data-bs-toggle="modal" data-bs-target="#deleteService"
                                (click)="deleteService('CARB', passengerIndex, serviceIndex)" class="deleteIcon"
                                alt="Cancel Item">
                                <i class="fa fa-trash"></i>
                              </a>
                            </div>
                          </div>
                        </li>
                        <li class="divider"></li>
                      </ng-template>
                      <ng-template
                        [ngIf]="passenger.passengerOtherDetails.passengerSelectedProductClimateServiceDetail.length > 0">
                        <li
                          *ngFor="let serviceDetail of passenger.passengerOtherDetails.passengerSelectedProductClimateServiceDetail; let serviceIndex = index">
                          <div class="row">
                            <div class="col-md-1 pl-0 pr-0 text-right">
                              <i class="fa fa-leaf grn"></i>
                            </div>
                            <div class="col-md-5">{{ serviceDetail.baggageName }}</div>
                            <div class="col-md-5">{{ serviceDetail.flightSegmentNumber }}</div>
                            <div class="col-md-1 pl-0 pr-0">
                              <a href="#" (click)="removeServiceFromPassenger('CARB', passengerIndex, serviceIndex)"
                                class="deleteIcon" alt="Cancel Item">
                                <i class="fa fa-trash"></i>
                              </a>
                            </div>
                          </div>
                        </li>
                        <li class="divider"></li>
                      </ng-template>
                      <!--end-->
                    </ul>
                  </div>
                </li>
                <li *ngIf="yourBookingScreen && !yourBookingScreen.booking.isDisrupted" class="ps-1">
                  <a *ngIf="!isSMEUser">
                    <i (click)="addPassengerDetails(passengerIndex)" class="fa fa-id-card iconColor"></i>
                  </a>
                </li>
                <li *ngIf="yourBookingScreen && yourBookingScreen.booking.isDisrupted" class="ps-1">
                  <i class="fa fa-exclamation-triangle red"></i>
                </li>
                <li class="ps-1">
                  <span> {{ passenger.passengerName }} {{ passenger.passengerSurName }} </span>
                </li>
              </ul>
            </div>
            <div class="col-sm-3" style="display: flex">
              <ng-template [ngIf]="
                  passenger.passengerOtherDetails.passengerBaggageDetails.length === 0 &&
                  passenger.passengerOtherDetails.passengerMealDetails.length === 0 &&
                  passenger.passengerOtherDetails.passengerDisablityServiceDetail.length === 0 &&
                  passenger.passengerOtherDetails.passengerSelectedBaggageDetail.length === 0 &&
                  passenger.passengerOtherDetails.passengerSelectedMealDetails.length === 0 &&
                  passenger.passengerOtherDetails.passengerSelectedDisablityServiceDetail.length === 0 &&
                  passenger.passengerOtherDetails.passengerSelectedSeatDetails.length === 0 &&
                  passenger.passengerOtherDetails.passengerSeatDetails.length === 0 &&
                  passenger.passengerOtherDetails.passengerSelectedProductClimateServiceDetail.length === 0 &&
                  passenger.passengerOtherDetails.passengerProductClimateServiceDetail.length === 0
                ">
                <i class="fa fa-suitcase fa-off"> </i>
                <i class="fa fa-utensils fa-off"> </i>
                <i class="fa fa-wheelchair fa-off"> </i>
                <i class="fa fa-leaf fa-off"></i>
              </ng-template>
              <ng-template [ngIf]="
                  passenger.passengerOtherDetails.passengerBaggageDetails.length !== 0 ||
                  passenger.passengerOtherDetails.passengerMealDetails.length !== 0 ||
                  passenger.passengerOtherDetails.passengerDisablityServiceDetail.length !== 0 ||
                  passenger.passengerOtherDetails.passengerSelectedBaggageDetail.length !== 0 ||
                  passenger.passengerOtherDetails.passengerSelectedMealDetails.length !== 0 ||
                  passenger.passengerOtherDetails.passengerSelectedDisablityServiceDetail.length !== 0 ||
                  passenger.passengerOtherDetails.passengerSelectedSeatDetails.length !== 0 ||
                  passenger.passengerOtherDetails.passengerSeatDetails.length !== 0 || 
                  passenger.passengerOtherDetails.passengerSelectedProductClimateServiceDetail.length !== 0 ||
                  passenger.passengerOtherDetails.passengerProductClimateServiceDetail.length !== 0
                ">
                <ng-template [ngIf]="passenger.passengerOtherDetails.passengerSeatDetails.length > 0">
                  <div *ngFor="let seat of passenger.passengerOtherDetails.passengerSeatDetails" class="ps-1 pe-1">
                    <i class="baIcn ba-flight-seat pe-1"></i>
                    {{ seat.seatRowNumber }} {{ seat.seatCoulmnName }}
                  </div>
                </ng-template>
                <ng-template [ngIf]="passenger.passengerOtherDetails.passengerSelectedSeatDetails.length > 0">
                  <div *ngFor="let seat of passenger.passengerOtherDetails.passengerSelectedSeatDetails"
                    class="ps-1 pe-1">
                    <i class="baIcn ba-flight-seat pe-1 grn"></i>
                    {{ seat.seatRowNumber }} {{ seat.seatCoulmnName }}
                  </div>
                </ng-template>
                <ng-template
                  [ngIf]="passenger.passengerOtherDetails.passengerBaggageDetails.length > 0 || passenger.passengerOtherDetails.passengerSelectedBaggageDetail.length > 0">
                  <span class="pl-2"><i class="baIcn ba-check-bag ba-mt3 ba-3x mb-1"> </i></span>
                </ng-template>
                <ng-template
                  [ngIf]="passenger.passengerOtherDetails.passengerMealDetails.length > 0 || passenger.passengerOtherDetails.passengerSelectedMealDetails.length > 0">
                  <i class="fa fa-utensils"> </i>
                </ng-template>
                <ng-template
                  [ngIf]="passenger.passengerOtherDetails.passengerDisablityServiceDetail.length > 0 || passenger.passengerOtherDetails.passengerSelectedDisablityServiceDetail.length > 0">
                  <i class="fa fa-wheelchair"> </i>
                </ng-template>
                <ng-template
                  [ngIf]="passenger.passengerOtherDetails.passengerProductClimateServiceDetail.length > 0 || passenger.passengerOtherDetails.passengerSelectedProductClimateServiceDetail.length > 0">
                  <i class="fa fa-leaf"> </i>
                </ng-template>

              </ng-template>
            </div>
            <div class="col-md-4 pt-7 hidden-sm hidden-xs hidden-md">
              <div class="row smallFontSSize">
                <div class="col-sm-2">{{ passenger.passengerType }}</div>
                <div class="col-sm-3">{{ roundPassengerDetailsPrice(passenger.basePrice) }}</div>
                <div class="col-sm-3">{{ roundPassengerDetailsPrice(passenger.taxPrice) }}</div>
                <div class="col-sm-4">
                  <a href="#" title="View Breakdown" class="textgrayColor iconColor dropdown-toggle"
                    data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {{ roundPassengerDetailsPrice(passenger.totalPrice) }} {{ passenger.currency }}
                  </a>
                  <div class="showHideToggle toggleOrderDetails Yourbookpopup dropdown-menu">
                    <h4 class="mb-3" id="exampleModalLabel">{{ passenger.passengerName }} {{ passenger.passengerSurName
                      }}</h4>
                    <table class="table table-bordered">
                      <tr class="">
                        <th>Service</th>
                        <th>Base</th>
                        <th>Tax</th>
                        <th>Total</th>
                      </tr>

                      <tr>
                        <td class="">Flight</td>
                        <td class="">{{ roundPassengerDetailsPrice(passenger.flightPrice) }}</td>
                        <td class="">{{ roundPassengerDetailsPrice(passenger.flightTax) }}</td>
                        <td class="">{{ roundPassengerDetailsPrice(passenger.flightTotal) }}</td>
                      </tr>

                      <!--baggage-->
                      <ng-template [ngIf]="passenger.passengerOtherDetails.passengerBaggageDetails.length > 0">
                        <tr
                          *ngFor="let baggageDetail of passenger.passengerOtherDetails.passengerBaggageDetails; let serviceIndex = index">
                          <ng-template [ngIf]="baggageDetail.total > 0">
                            <td class="">Bag</td>
                            <td class="">{{ baggageDetail.price }}</td>
                            <td class="">{{ baggageDetail.tax }}</td>
                            <td class="">{{ baggageDetail.total }}</td>
                          </ng-template>
                        </tr>
                      </ng-template>
                      <!--end-->
                      <!-- product climate -->
                      <ng-template
                        [ngIf]="passenger.passengerOtherDetails.passengerProductClimateServiceDetail.length > 0">
                        <tr
                          *ngFor="let baggageDetail of passenger.passengerOtherDetails.passengerProductClimateServiceDetail; let serviceIndex = index">
                          <ng-template [ngIf]="baggageDetail.total > 0">
                            <td class="">SAF</td>
                            <td class="">{{ baggageDetail.price }}</td>
                            <td class="">{{ baggageDetail.tax }}</td>
                            <td class="">{{ baggageDetail.total }}</td>
                          </ng-template>
                        </tr>
                      </ng-template>
                      <!--end-->
                      <!--Meal-->
                      <ng-template [ngIf]="passenger.passengerOtherDetails.passengerMealDetails.length > 0">
                        <tr
                          *ngFor="let baggageDetail of passenger.passengerOtherDetails.passengerMealDetails; let serviceIndex = index">
                          <ng-template [ngIf]="baggageDetail.total > 0">
                            <td class="">Meal</td>
                            <td class="">{{ baggageDetail.price }}</td>
                            <td class="">{{ baggageDetail.tax }}</td>
                            <td class="">{{ baggageDetail.total }}</td>
                          </ng-template>
                        </tr>
                      </ng-template>
                      <!--end-->
                      <!--Disablity Service-->
                      <ng-template [ngIf]="passenger.passengerOtherDetails.passengerDisablityServiceDetail.length > 0">
                        <tr
                          *ngFor="let baggageDetail of passenger.passengerOtherDetails.passengerDisablityServiceDetail; let serviceIndex = index">
                          <ng-template [ngIf]="baggageDetail.total > 0">
                            <td class="">Disablity Service</td>
                            <td class="">{{ baggageDetail.price }}</td>
                            <td class="">{{ baggageDetail.tax }}</td>
                            <td class="">{{ baggageDetail.total }}</td>
                          </ng-template>
                        </tr>
                      </ng-template>
                      <!--end-->
                      <!--Seat Service-->
                      <ng-template [ngIf]="passenger.passengerOtherDetails.passengerSeatDetails.length > 0">
                        <tr
                          *ngFor="let baggageDetail of passenger.passengerOtherDetails.passengerSeatDetails; let serviceIndex = index">
                          <ng-template [ngIf]="baggageDetail.seatPrice > 0">
                            <td class="">Seat</td>
                            <td class="">{{ baggageDetail.seatPrice }}</td>
                            <td class="">0</td>
                            <td class="">{{ baggageDetail.seatPrice }}</td>
                          </ng-template>
                        </tr>
                      </ng-template>
                      <!--end-->

                      <tr>
                        <th class="">Total</th>
                        <th class="">{{ roundPassengerDetailsPrice(passenger.basePrice) }}</th>
                        <th class="">{{ roundPassengerDetailsPrice(passenger.taxPrice) }}</th>
                        <th class="">{{ roundPassengerDetailsPrice(passenger.totalPrice) }} {{ passenger.currency }}
                        </th>
                      </tr>
                    </table>
                    <h4 class="mb-3" id="exampleModalLabel">Tax Breakdown</h4>

                    <!-- Additional Tax Details -->
                    <table class="table table-bordered">
                      <tr>
                        <th>AddL Tax Type</th>
                        <th>Tax Code</th>
                        <th>Amount</th>
                      </tr>
                      <tr *ngFor="let taxDetails of passenger.taxDetails">
                        <td>{{ taxDetails.addLTaxType }}</td>
                        <td>{{ taxDetails.taxCode }}</td>
                        <td>{{ roundPassengerDetailsPrice(taxDetails.amount) }} {{ taxDetails.amountCode }}</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <!-- Passenger Ticket Details -->
            <ng-template [ngIf]="passenger.passengerOtherDetails.passengerTicketDetails.length > 0">
              <details class="pl-4 ms-3 w-90">
                <summary class="p-2">Additional Ticket Details</summary>
                <div *ngFor="let passengerTicketDetails of passenger.passengerOtherDetails.passengerTicketDetails">
                  <div class="row">
                    <div class="col-md-7 p-1">Reporting Type</div>
                    <div class="col-md-4 p-1">{{ passengerTicketDetails.reportingType }}</div>
                  </div>
                  <div *ngFor="let couponInfo of passengerTicketDetails.couponInfo">
                    <details>
                      <summary>
                        <b>Coupon {{ couponInfo.couponNumber }}</b>
                      </summary>
                      <div class="row">
                        <div class="col-md-7 pl-5 pt-2">Fare Basis Code</div>
                        <div class="col-md-4 pl-5 pt-2">{{ couponInfo.fareBasisCode }}</div>
                        <div class="col-md-7 pl-5 pt-2">Fare Basis Status</div>
                        <div class="col-md-4 pl-5 pt-2">{{ couponInfo.status }}</div>

                        <ng-template [ngIf]="couponInfo.additionalCouponInfo !== undefined">
                          <div class="col-md-7 pl-5 pt-2">Reason for Issuance</div>
                          <div class="col-md-4 pl-5 pt-2">{{ couponInfo.additionalCouponInfo.rfic }}</div>
                          <div class="col-md-7 pl-5 pt-2">RFIC Code</div>
                          <div class="col-md-4 pl-5 pt-2">{{ couponInfo.additionalCouponInfo.code }}</div>
                          <div class="col-md-7 pl-5 pt-2">Description</div>
                          <div class="col-md-4 pl-5 pt-2">{{ couponInfo.additionalCouponInfo.description }}</div>
                          <div class="col-md-7 pl-5 pt-2">Interconnection Ticket Number</div>
                          <div class="col-md-4 pl-5 pt-2">{{ couponInfo.additionalCouponInfo.inConnectionDocNbr }}</div>
                          <div class="col-md-7 pl-5 pt-2">Interconnection PN Number.</div>
                          <div class="col-md-4 pl-5 pt-2">{{ couponInfo.additionalCouponInfo.inConnectonCpnNbr }}</div>
                        </ng-template>
                      </div>
                      <div class="col-md-1 pl-0 pr-0"></div>
                    </details>
                    <hr />
                  </div>
                </div>
              </details>
            </ng-template>
          </div>
        </ng-template>
      </div>
      <div class="totpn card">
        <div class="row">
          <div class="col-sm-5"></div>
          <div class="col-sm-3"></div>

          <div class="col-sm-4">
            <div class="row smallFontSSize">
              <div class="col-sm-2"></div>
              <div class="col-sm-3"></div>
              <div class="col-sm-3 pr-0">{{ roundPassengerDetailsPrice(passengerDetailScreenData.totalTax) }}</div>
              <div class="col-sm-4">
                {{ roundPassengerDetailsPrice(passengerDetailScreenData.totalPrice) }} <span class="small-txt">{{
                  passengerDetailScreenData.currency }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</ng-template>
<!--END-->

<!-- cancel held booking -->
<div class="modal cancelPopup" id="deleteService" tabindex="-1" role="dialog" aria-hidden="true"
  aria-labelledby="disruptBookingPopupTitle">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="CancelSeatsTitle">CANCEL SERVICES</h5>
        <button type="button" class="btn-close close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">Confirm to Cancel Service</div>
      <div class="modal-footer">
        <button type="button" class="grayBtn" data-bs-dismiss="modal" (click)="confirmDeleteService()"
          aria-label="Close">Confirm</button>
        <button type="button" class="grayBtn" data-bs-dismiss="modal" aria-label="Close">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-- cancel held booking -->